// extracted by mini-css-extract-plugin
export default {"text":"SectionSplitterLabel_text__q0JAn","sectionSplitter":"SectionSplitterLabel_sectionSplitter__mWsIe"};